<template>
  <transition name="bs">
    <div class="bs-overlay" @click.self="onBackdrop">
      <div class="bs-sheet" role="dialog" aria-modal="true">
        <span class="bs-handle"></span>
        <div class="bs-title" v-if="title">{{ title }}</div>
        <div class="bs-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// Alttan açılan işlem sayfası (bottom sheet). Dış tıklama ve Esc ile kapanır; persistent verilirse yalnızca içindeki düğmelerle kapanır.
export default {
  name: "BottomSheet",
  props: {
    title: { type: String, default: "" },
    persistent: { type: Boolean, default: false },
  },
  created() {
    this.onKeydown = (e) => {
      if (e.key === "Escape" && !this.persistent) this.$emit("close");
    };
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onBackdrop() {
      if (!this.persistent) this.$emit("close");
    },
  },
};
</script>

<style scoped>
.bs-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1950;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: rgba(9, 22, 52, 0.45);
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
}

.bs-sheet {
  box-sizing: border-box;
  width: 100%;
  max-width: 560px;
  max-height: 85vh;
  overflow-y: auto;
  padding: 8px 16px calc(env(safe-area-inset-bottom, 0px) + 16px) 16px;
  border-radius: 20px 20px 0 0;
  background-color: #ffffff;
  box-shadow: 0 -8px 32px rgba(9, 33, 84, 0.2);
  color: #092154;
}

.bs-handle {
  display: block;
  width: 40px;
  height: 4px;
  margin: 0 auto 12px auto;
  border-radius: 4px;
  background-color: #D9DDE5;
}

.bs-title {
  margin-bottom: 8px;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  font-size: 15px;
  color: #092154;
}

.bs-body {
  display: flex;
  flex-direction: column;
}

.bs-enter-active,
.bs-leave-active {
  transition: background-color 0.2s ease;
}

.bs-enter-active .bs-sheet,
.bs-leave-active .bs-sheet {
  transition: transform 0.25s ease;
}

.bs-enter,
.bs-leave-to {
  background-color: rgba(9, 22, 52, 0);
}

.bs-enter .bs-sheet,
.bs-leave-to .bs-sheet {
  transform: translateY(100%);
}
</style>
